import vendorApi from '../../api/manager/vendor'
import router from '../../router'
import {STATUS_MESSAGE} from '@/utils/notificationMessage'
import Vue from 'vue'

export const state = () => ({
  vendor: {

  },
  imageVendor: '',
  errorVendorMessage: {

  }
})

export const getter = {}

export const mutations = {
  DETAIL_VENDOR (state, slug) {
    state.vendor = { ...slug }
    state.imageVendor = slug.logo
  },
  CHANGE_ERROR_MESSAGE (state, slug) {
    state.errorVendorMessage = { ...slug }
  }
}

export const actions = {
  async getDetailVendor ({commit}, params) {
    try {
      const res = await vendorApi.getDetailVendor(params)
      if (res.status === 200) {
        commit('DETAIL_VENDOR', res.data.data)
      }
    } catch (error) {

    }
  },
  async editVendor ({commit}, params) {
    const vm = new Vue()
    try {
      const res = await vendorApi.editVendor(params)
      if (res.status === 201) {
        vm.$toastr.s(STATUS_MESSAGE.UPDATED)
        commit('DETAIL_VENDOR', res.data.data)
        router.push('/manager/company')
        commit('CHANGE_ERROR_MESSAGE', '')
      }
    } catch (error) {
      commit('CHANGE_ERROR_MESSAGE', error.response.data.error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getter,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/manager/vendor.js